export default __webpack_public_path__ + "static/media/pictogramBeaconAccessibility48.6fece370.svg";